export const AQUARIST_IOS_URL =
  'https://apps.apple.com/app/aquarist/id6501983049';

export const AQUARIST_ANDROID_URL =
  'https://play.google.com/store/apps/details?id=com.aquarist';
